import React from 'react';

export function BeanbagImage(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-name="Group 2982"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={584}
      height={528.88}
      {...props}>
      <defs>
        <linearGradient
          id="prefix__a"
          y1={0.5}
          x2={1}
          y2={0.5}
          gradientUnits="objectBoundingBox">
          <stop offset={0.135} stopColor="#4d4ccd" />
          <stop offset={0.562} stopColor="#10105e" />
          <stop offset={0.655} stopColor="#0f0f5a" />
          <stop offset={0.73} stopColor="#0d0d50" />
          <stop offset={0.799} stopColor="#0a0a3f" />
          <stop offset={0.865} stopColor="#060627" />
          <stop offset={0.927} stopColor="#010109" />
          <stop offset={0.943} />
        </linearGradient>
        <linearGradient
          id="prefix__b"
          x1={-0.159}
          y1={-0.729}
          x2={0.811}
          y2={1.08}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__c"
          x1={-2.886}
          y1={67.543}
          x2={-1.886}
          y2={67.543}
          gradientUnits="objectBoundingBox">
          <stop offset={0.019} stopColor="#161765" />
          <stop offset={0.042} stopColor="#1b1c6f" />
          <stop offset={0.125} stopColor="#2d2d91" />
          <stop offset={0.211} stopColor="#3b3aab" />
          <stop offset={0.298} stopColor="#4544be" />
          <stop offset={0.388} stopColor="#4b4ac9" />
          <stop offset={0.486} stopColor="#4d4ccd" />
          <stop offset={1} stopColor="#959ffc" />
        </linearGradient>
        <linearGradient
          id="prefix__d"
          x1={0.297}
          y1={1.368}
          x2={0.717}
          y2={-0.311}
          gradientUnits="objectBoundingBox">
          <stop offset={0} stopColor="#4d4ccd" />
          <stop offset={0.23} stopColor="#504fcf" />
          <stop offset={0.445} stopColor="#5a5bd5" />
          <stop offset={0.656} stopColor="#6a6ee0" />
          <stop offset={0.861} stopColor="#8188ef" />
          <stop offset={1} stopColor="#959ffc" />
        </linearGradient>
        <linearGradient
          id="prefix__e"
          x1={0.573}
          y1={0.004}
          x2={0.427}
          y2={0.996}
          gradientUnits="objectBoundingBox">
          <stop offset={0.173} stopColor="#4d4ccd" />
          <stop offset={0.801} stopColor="#959ffc" />
        </linearGradient>
      </defs>
      <g data-name="Group 908">
        <path
          data-name="Path 1354"
          d="M126.161 156.981a73.943 73.943 0 01-54.409-33.088C58.077 102.642 49.03 73.725 33.718 53.345 57.349 58.882 80.259 78.203 95.64 96.98s25.467 41.474 31.753 64.917"
          fill="#374adb"
        />
        <g data-name="Group 907">
          <path
            data-name="Path 1355"
            d="M126.161 155.844a73.064 73.064 0 01-47.509-24.648c-6.115-7.02-10.593-15.35-14.78-23.615-4.466-8.817-8.5-17.842-12.831-26.725-4.746-9.736-9.833-19.395-16.342-28.085l-1.284 1.67c18.683 4.423 35.126 16.308 48.695 29.494a153.874 153.874 0 0118.5 21.437 157.99 157.99 0 0114.588 25.565 200.129 200.129 0 0111.1 31.262 1.138 1.138 0 002.192-.6c-5.185-19.284-12.878-38.065-24.06-54.676a154.567 154.567 0 00-18.422-22.325A148.306 148.306 0 0063.28 65.642c-8.93-5.983-18.756-10.9-29.259-13.39-.868-.205-1.918.823-1.284 1.67 11.958 15.967 19.245 34.848 28.06 52.591 4.231 8.516 8.717 17.122 14.753 24.521a75.214 75.214 0 0050.612 27.087c1.456.14 1.446-2.135 0-2.274z"
            fill="#374adb"
          />
        </g>
      </g>
      <g data-name="Group 910">
        <path
          data-name="Path 1356"
          d="M133.589 141.033a81.846 81.846 0 01-45.3-54c-6.792-27.134-2.48-58.561-15.029-85.865 22.81 14.194 40.168 40.984 49.628 66.129s11.977 52.522 10.245 79.332"
          fill="#98a4fa"
        />
        <g data-name="Group 909">
          <path
            data-name="Path 1357"
            d="M134.162 140.055a79.544 79.544 0 01-23.644-16.364 81.791 81.791 0 01-16.444-23.614c-4.291-9.342-6.343-19.428-7.587-29.582-1.354-11.043-1.862-22.169-3.109-33.223-1.255-11.133-3.242-22.275-7.43-32.716q-.8-2-1.7-3.963l-1.556 1.555c16.853 10.529 29.667 26.811 39.192 44.022a164.805 164.805 0 0119.353 61.56 221.993 221.993 0 01.764 38.9c-.093 1.461 2.181 1.455 2.274 0a225.243 225.243 0 00-.372-35.061 177.7 177.7 0 00-6.461-34.291 161.981 161.981 0 00-11.927-29.161 150.884 150.884 0 00-16.867-25.608 106.1 106.1 0 00-21.776-20.34q-1.5-1.024-3.032-1.982c-1.047-.654-1.994.6-1.556 1.555 4.742 10.375 7.113 21.641 8.512 32.911 1.38 11.116 1.893 22.316 3.138 33.445 1.159 10.365 2.934 20.725 6.982 30.392a83.829 83.829 0 0015.736 24.457 81.8 81.8 0 0023.036 17.487q1.644.833 3.329 1.586c1.324.594 2.481-1.364 1.147-1.964z"
            fill="#98a4fa"
          />
        </g>
      </g>
      <path
        data-name="Path 1358"
        d="M116.362 112.129a38.417 38.417 0 01-7.355-8.033 53.735 53.735 0 01-5.226-9.649 79.314 79.314 0 01-3.518-10.381c-.939-3.526-1.662-7.094-2.318-10.661-.6-3.571-1.143-7.136-1.684-10.689-.5-3.56-1.086-7.092-1.689-10.615a100.483 100.483 0 00-5.7-20.67c3.894 6.122 6.3 13.14 8.011 20.18.891 3.523 1.538 7.092 2.207 10.639l1.836 10.632q.882 5.291 2.109 10.486a99.673 99.673 0 002.94 10.228 56.335 56.335 0 0010.387 18.533z"
        fill="#374adb"
      />
      <path
        data-name="Path 1359"
        d="M222.95 290.678a58.014 58.014 0 01-8.3-14.169 81.186 81.186 0 01-4.655-15.877 119.673 119.673 0 01-1.907-16.416c-.271-5.495-.211-10.984-.05-16.45.4-10.916 1.4-21.7 1.751-32.477a151.346 151.346 0 00-1.882-32.277c3.8 10.258 5.13 21.363 5.431 32.284.306 10.958-.341 21.849-.758 32.639q-.368 8.081-.2 16.127a150.7 150.7 0 001.108 16.01c1.35 10.589 4.171 21.049 9.462 30.606z"
        fill="#374adb"
      />
      <path
        data-name="Path 1360"
        d="M104.762 135.352a34.838 34.838 0 01-9.271-5.443c-1.428-1.1-2.782-2.289-4.113-3.5s-2.621-2.471-3.86-3.774q-3.748-3.886-7.092-8.127c-1.116-1.41-2.214-2.835-3.274-4.289s-2.074-2.943-3.065-4.45-1.952-3.04-2.861-4.608l-2.6-4.69c-1.735-3.113-3.349-6.275-5.1-9.346A96.637 96.637 0 0051.62 69.602a47.491 47.491 0 017.754 7.475 84.122 84.122 0 016.349 8.734c3.859 6.043 7.134 12.444 10.853 18.341q1.423 2.221 2.945 4.385c1 1.451 2.018 2.893 3.066 4.312 2.114 2.825 4.279 5.617 6.564 8.305a103.061 103.061 0 007.218 7.737 42.679 42.679 0 008.393 6.461z"
        fill="#98a4fa"
      />
      <path
        data-name="Path 1361"
        d="M351.649 357.879a55.06 55.06 0 01-10.323-10.948 76.275 76.275 0 01-7.5-13.146 112.961 112.961 0 01-5.24-14.194c-1.441-4.829-2.6-9.726-3.662-14.63-1.005-4.91-1.925-9.822-2.855-14.719a438.42 438.42 0 00-2.931-14.629 130.011 130.011 0 00-9.292-28.264c5.462 8.42 8.976 18.021 11.588 27.7 1.342 4.843 2.39 9.75 3.449 14.637 1.019 4.9 1.96 9.795 3.006 14.657a215.49 215.49 0 003.448 14.462 133.518 133.518 0 004.657 14.06c3.649 9.144 8.646 17.841 15.655 25.014z"
        fill="#374adb"
      />
      <path
        data-name="Path 1362"
        d="M480.325 313.982c-6.2-12.435 17.409-20.607 24.535-32.534s17.66-21.348 27.214-31.436a244.489 244.489 0 0051.843-83.658c2.021 61.787-32.481 148.1-100.875 185.618"
        fill="#374adb"
      />
      <path
        data-name="Path 1363"
        d="M490.975 274.537c-10.125-17.4-4.518-40.034 6.2-57.075s25.959-30.838 36.983-47.682c10.969 25.03 7.251 54.645-4.31 79.406s-30.216 45.457-49.525 64.8"
        fill="#98a4fa"
      />
      <path
        data-name="Path 1364"
        d="M483.386 302.614a35.4 35.4 0 010-14.3 45.227 45.227 0 012.071-6.951 66.138 66.138 0 013.051-6.555c2.25-4.251 4.836-8.259 7.309-12.284 1.255-2 2.488-4.007 3.667-6.036s2.276-4.089 3.454-6.173c4.637-8.3 9.5-16.413 13.87-24.768a127.62 127.62 0 0010.591-26.2c-1.254 9.444-4.535 18.567-8.531 27.212-3.989 8.677-8.746 16.93-13.3 25.214-1.119 2.064-2.274 4.172-3.507 6.231s-2.5 4.079-3.782 6.081c-2.6 3.984-5.251 7.89-7.642 11.913a65.421 65.421 0 00-3.283 6.174 43.459 43.459 0 00-2.468 6.511 40.485 40.485 0 00-1.5 13.931z"
        fill="#374adb"
      />
      <path
        data-name="Path 1365"
        d="M572.261 205.192a44.494 44.494 0 01-1.385 8.438 74.026 74.026 0 01-2.623 8.168c-1.01 2.679-2.166 5.3-3.377 7.888s-2.51 5.142-3.887 7.647c-2.73 5.025-5.712 9.908-8.889 14.659-1.592 2.375-3.218 4.726-4.9 7.04s-3.426 4.581-5.213 6.819-3.627 4.441-5.545 6.58l-5.791 6.279c-3.853 4.18-7.8 8.254-11.558 12.476-7.6 8.367-14.658 17.222-20.063 27.262a81.928 81.928 0 017.87-15.193 142.625 142.625 0 0110.259-13.747q5.538-6.536 11.323-12.8l5.707-6.307c1.89-2.079 3.708-4.226 5.486-6.414s3.5-4.422 5.189-6.685 3.364-4.536 4.986-6.849c3.218-4.641 6.333-9.36 9.223-14.214a154.224 154.224 0 007.937-14.96 65.4 65.4 0 005.251-16.087z"
        fill="#98a4fa"
      />
      <g data-name="Group 911">
        <path
          data-name="Path 1366"
          d="M340.087 346.836l-3.01-.455a2.693 2.693 0 00-1.877.08 1.482 1.482 0 00-.453 2.076 2.739 2.739 0 001.3.985l1.326.6a5.931 5.931 0 001.639.562 2.321 2.321 0 001.858-.484 2.157 2.157 0 00.72-1.472 1.725 1.725 0 00-.833-1.607 1.147 1.147 0 00-1.555.408 1.162 1.162 0 00.408 1.556c.149.094-.2-.182-.088-.061.021.023-.174-.233-.115-.139s-.082-.2-.072-.171c.05.145-.005-.323-.011-.1s.069-.243.016-.092a.389.389 0 00-.021.071c-.009.1.05-.171.07-.157a.943.943 0 01-.071.132c-.075.145.179-.178.055-.073a.331.331 0 00-.054.052c-.072.094.206-.159.112-.089-.02.014-.046.021-.064.036.222-.193.226-.061.106-.052-.22.017.219.008 0 .007a.992.992 0 00-.231-.008c.012 0 .226.048.108.011-.049-.016-.1-.023-.154-.036a4.555 4.555 0 01-.458-.157c-.12-.045.081.033.085.036a.82.82 0 00-.146-.065l-.273-.123-.975-.44-.507-.229c-.066-.03-.133-.058-.2-.093l-.079-.047c-.131-.073.054.03.077.065a.682.682 0 00-.134-.131c-.007-.005.149.206.094.112s.064.168.06.151a.876.876 0 01-.1.644.714.714 0 01-.285.251c.068-.041-.363.2-.353.129a.932.932 0 01.127 0s-.281-.042-.134-.018l.129.02.258.039.559.084 2.537.383a1.243 1.243 0 00.876-.115 1.162 1.162 0 00.523-.679 1.15 1.15 0 00-.794-1.4z"
          fill="#374adb"
        />
      </g>
      <g data-name="Group 912">
        <path
          data-name="Path 1367"
          d="M339.502 347.379q-1.814-.266-3.61-.628a1.155 1.155 0 00-1.195.408 1.119 1.119 0 00-.089 1.262 4.878 4.878 0 006.388 1.4 1.137 1.137 0 10-1.148-1.963c-.092.055-.188.1-.282.153-.172.093.2-.065.066-.024-.051.015-.1.038-.15.055a5.839 5.839 0 01-.59.146c-.129.03.307-.026.079-.012-.042 0-.085.007-.127.01-.108.007-.215.008-.321.006s-.215-.012-.322-.021c-.2-.015.22.039.079.011-.052-.01-.105-.018-.158-.029a4.681 4.681 0 01-.588-.169c-.1-.035-.152-.116.064.03a1.253 1.253 0 00-.146-.068c-.087-.042-.171-.089-.254-.137s-.179-.116-.268-.176c-.161-.108.147.137.053.041-.037-.037-.083-.07-.122-.1q-.107-.1-.2-.2c-.036-.039-.071-.08-.106-.12-.141-.155.153.208.02.026l-1.284 1.67q1.8.363 3.609.628a1.25 1.25 0 00.876-.115 1.164 1.164 0 00.523-.68 1.15 1.15 0 00-.794-1.4z"
          fill="#eaedfd"
        />
      </g>
      <path
        data-name="Path 1368"
        d="M2357.2 907.844h-409.95l-51.831 30.956h512.251z"
        transform="translate(-1885.798 -503.658)"
        fill="url(#prefix__a)"
      />
      <path
        data-name="Path 2464"
        d="M67.507 138.812h398.28a23.191 23.191 0 0123.191 23.191V390.66a23.191 23.191 0 01-23.191 23.191H67.507a23.191 23.191 0 01-23.191-23.191V162.003a23.191 23.191 0 0123.191-23.191z"
        fill="#5768e3"
      />
      <rect
        data-name="Rectangle 624"
        width={420.708}
        height={255.71}
        rx={23.191}
        transform="translate(55.29 149.992)"
        fill="url(#prefix__b)"
      />
      <path
        data-name="Path 1369"
        d="M1892.685 948.689h511.571a9.882 9.882 0 019.853 9.853v3.041a9.882 9.882 0 01-9.853 9.853h-511.571c-13.222.173-13.339-22.922 0-22.747z"
        transform="translate(-1882.724 -513.546)"
        fill="url(#prefix__c)"
      />
      <path
        data-name="Path 1370"
        d="M477.974 388.788c1.1-24.949 19.872-48.1 44.053-54.337a112.335 112.335 0 01-8.645 27.388c13.5-19.837 41.633-22.873 60.212-38.056-3.751 35.743-26.438 68.948-58.374 85.433-10.12 5.224-21.7 8.894-32.847 6.573-5.951-1.238-12.213-4.119-17.806-1.734"
        fill="#374adb"
      />
      <rect
        data-name="Rectangle 625"
        width={312.235}
        height={355.788}
        rx={13}
        transform="translate(115.51 48.398)"
        fill="#d0d4ff"
      />
      <g data-name="Group 913">
        <path
          data-name="Path 1371"
          d="M122.225 382.887a9.259 9.259 0 009.233 9.232h280.874a9.259 9.259 0 009.231-9.232V91.665H122.225z"
          fill="#fff"
        />
        <path
          data-name="Path 1372"
          d="M412.332 59.582H131.458a9.26 9.26 0 00-9.233 9.233v22.851h299.336V68.815a9.259 9.259 0 00-9.229-9.233z"
          fill="#eaedfd"
        />
      </g>
      <path
        data-name="Path 1373"
        d="M310.08 233.841a38.188 38.188 0 00-38.187 38.187c0 .6.018 1.194.045 1.787h-.09c.027-.593.045-1.188.045-1.787a38.5 38.5 0 00-.2-3.9 37.928 37.928 0 00-2.8-10.959q-.726-1.713-1.609-3.339a38.716 38.716 0 00-1.556-2.592c-.454-.7-.923-1.388-1.422-2.054a38.4 38.4 0 00-7.752-7.753c-.666-.5-1.354-.966-2.053-1.421a36.891 36.891 0 00-2.593-1.556q-1.623-.882-3.338-1.608a37.976 37.976 0 00-10.96-2.8 38.647 38.647 0 00-3.9-.2c-.6 0-1.195.018-1.787.045v-.09c.593.027 1.188.045 1.787.045a38.611 38.611 0 003.9-.2 37.942 37.942 0 0010.96-2.8q1.712-.725 3.338-1.608a38.075 38.075 0 002.593-1.556c.7-.455 1.387-.923 2.053-1.422a38.343 38.343 0 007.752-7.753c.5-.666.968-1.354 1.422-2.053.549-.844 1.073-1.7 1.556-2.593q.883-1.622 1.609-3.338a37.922 37.922 0 002.8-10.96 38.488 38.488 0 00.2-3.9c0-.6-.018-1.2-.045-1.788h.09a39.255 39.255 0 00-.045 1.788 38.187 38.187 0 1038.187-38.187h-96.49a18.06 18.06 0 00-18.007 18.008v10.706c-.038.623-.064 1.25-.064 1.883 0 .168.01.334.013.5h-.013v90.551h.013c0 .167-.013.334-.013.5 0 .633.026 1.26.064 1.883v10.706a18.061 18.061 0 0018.007 18.008h96.49a38.188 38.188 0 000-76.375z"
        fill="#374adb"
      />
      <path data-name="Line 8" fill="none" d="M122.225 91.665h299.336" />
      <circle
        data-name="Ellipse 46"
        cx={6.709}
        cy={6.709}
        r={6.709}
        transform="translate(142.158 68.715)"
        fill="#98a4fa"
      />
      <circle
        data-name="Ellipse 47"
        cx={6.709}
        cy={6.709}
        r={6.709}
        transform="translate(163.968 68.715)"
        fill="#98a4fa"
      />
      <circle
        data-name="Ellipse 48"
        cx={6.709}
        cy={6.709}
        r={6.709}
        transform="translate(186.487 68.715)"
        fill="#98a4fa"
      />
      <rect
        data-name="Rectangle 626"
        width={174.05}
        height={13.417}
        rx={6.709}
        transform="translate(222.083 68.715)"
        fill="#98a4fa"
      />
      <g data-name="Group 915">
        <g data-name="Group 914" fill="#374adb">
          <path
            data-name="Path 1374"
            d="M490.156 48.931c.013.293.022.588.022.884 0-.3.009-.591.023-.884z"
          />
          <path
            data-name="Path 1375"
            d="M470.395 68.737c.293-.014.588-.023.885-.023-.3 0-.592-.008-.885-.022z"
          />
          <path
            data-name="Path 1376"
            d="M490.2 88.497a18.49 18.49 0 01-.023-.884c0 .3-.009.591-.022.884z"
          />
          <path
            data-name="Path 1377"
            d="M490.178 49.815a19.213 19.213 0 01-.1 1.933 18.779 18.779 0 01-1.388 5.424q-.359.848-.8 1.652c-.239.44-.5.865-.771 1.283-.224.346-.456.687-.7 1.016a18.977 18.977 0 01-3.837 3.836c-.33.247-.671.478-1.017.7-.417.272-.843.532-1.283.771a20.77 20.77 0 01-1.651.8 18.749 18.749 0 01-3.548 1.1q-.924.189-1.876.287a19.187 19.187 0 01-1.933.1 19.159 19.159 0 011.933.1 18.8 18.8 0 015.424 1.388c.565.239 1.117.5 1.651.8a21.781 21.781 0 012.3 1.47 19.007 19.007 0 013.837 3.837c.247.33.479.67.7 1.016.272.418.532.844.771 1.283q.436.8.8 1.652a18.79 18.79 0 011.388 5.424 19.21 19.21 0 01.1 1.932 18.9 18.9 0 0118.9-18.9 18.9 18.9 0 01-18.9-18.904z"
          />
        </g>
        <path
          data-name="Path 1379"
          d="M470.395 68.737c.293-.014.588-.023.885-.023-.3 0-.592-.008-.885-.022z"
          fill="#374adb"
        />
        <path
          data-name="Path 1380"
          d="M490.2 88.497a18.49 18.49 0 01-.023-.884c0 .3-.009.591-.022.884z"
          fill="#374adb"
        />
        <path
          data-name="Path 1381"
          d="M490.178 49.815a19.213 19.213 0 01-.1 1.933 18.779 18.779 0 01-1.388 5.424q-.359.848-.8 1.652c-.239.44-.5.865-.771 1.283-.224.346-.456.687-.7 1.016a18.977 18.977 0 01-3.837 3.836c-.33.247-.671.478-1.017.7-.417.272-.843.532-1.283.771a20.77 20.77 0 01-1.651.8 18.749 18.749 0 01-3.548 1.1q-.924.189-1.876.287a19.187 19.187 0 01-1.933.1 19.159 19.159 0 011.933.1 18.8 18.8 0 015.424 1.388c.565.239 1.117.5 1.651.8a21.781 21.781 0 012.3 1.47 19.007 19.007 0 013.837 3.837c.247.33.479.67.7 1.016.272.418.532.844.771 1.283q.436.8.8 1.652a18.79 18.79 0 011.388 5.424 19.21 19.21 0 01.1 1.932 18.9 18.9 0 0118.9-18.9 18.9 18.9 0 01-18.9-18.904z"
          fill="#fccb88"
        />
        <path
          data-name="Path 1382"
          d="M490.156 48.931c.013.293.022.588.022.884 0-.3.009-.591.023-.884z"
          fill="#374adb"
        />
      </g>
      <g data-name="Group 917" fill="#fccb88">
        <g data-name="Group 916">
          <path
            data-name="Path 1383"
            d="M163.941 339.94c.009.187.015.375.015.564 0-.189.006-.377.014-.564z"
          />
          <path
            data-name="Path 1384"
            d="M151.333 352.572c.187-.008.375-.014.564-.014-.189 0-.377-.006-.564-.014z"
          />
          <path
            data-name="Path 1385"
            d="M163.969 365.177a13.105 13.105 0 01-.014-.564c0 .189-.006.377-.015.564z"
          />
          <path
            data-name="Path 1386"
            d="M163.953 340.504a12.156 12.156 0 01-.062 1.232q-.062.608-.183 1.2a11.95 11.95 0 01-.7 2.262q-.23.541-.508 1.054a12.917 12.917 0 01-.94 1.467 12.139 12.139 0 01-2.447 2.447c-.211.157-.428.3-.649.449-.266.173-.537.339-.818.491q-.513.279-1.054.508a12.082 12.082 0 01-4.693.947 12.013 12.013 0 014.693.947q.541.228 1.054.507c.28.152.552.318.818.492.221.143.438.291.649.448a12.329 12.329 0 011.311 1.136 12.086 12.086 0 011.136 1.312c.157.21.3.427.449.648.173.266.339.538.491.819q.278.511.508 1.053a11.94 11.94 0 01.7 2.263 12.137 12.137 0 01.245 2.429 12.055 12.055 0 0112.054-12.054 12.055 12.055 0 01-12.054-12.057z"
          />
        </g>
        <path
          data-name="Path 1388"
          d="M151.333 352.572c.187-.008.375-.014.564-.014-.189 0-.377-.006-.564-.014z"
        />
        <path
          data-name="Path 1389"
          d="M163.969 365.177a13.105 13.105 0 01-.014-.564c0 .189-.006.377-.015.564z"
        />
        <path
          data-name="Path 1390"
          d="M163.953 340.504a12.156 12.156 0 01-.062 1.232q-.062.608-.183 1.2a11.95 11.95 0 01-.7 2.262q-.23.541-.508 1.054a12.917 12.917 0 01-.94 1.467 12.139 12.139 0 01-2.447 2.447c-.211.157-.428.3-.649.449-.266.173-.537.339-.818.491q-.513.279-1.054.508a12.082 12.082 0 01-4.693.947 12.013 12.013 0 014.693.947q.541.228 1.054.507c.28.152.552.318.818.492.221.143.438.291.649.448a12.329 12.329 0 011.311 1.136 12.086 12.086 0 011.136 1.312c.157.21.3.427.449.648.173.266.339.538.491.819q.278.511.508 1.053a11.94 11.94 0 01.7 2.263 12.137 12.137 0 01.245 2.429 12.055 12.055 0 0112.054-12.054 12.055 12.055 0 01-12.054-12.057z"
        />
        <path
          data-name="Path 1391"
          d="M163.941 339.94c.009.187.015.375.015.564 0-.189.006-.377.014-.564z"
        />
      </g>
      <path
        data-name="Path 1392"
        d="M457.774 331.456c-21.706-22.769-53.894-11.681-76.673 3.151-23.691 15.427-40.582 38.678-64.084 54.591-2.329 1.577-4.7 3.1-7.113 4.535-11.311 6.736-21.884 14.859-29.416 25.841-6.042 8.809-9.616 19.165-8.726 29.932.869 10.521 3.866 18.787 8.429 25.225 13.2 18.625 38.75 21.274 59.747 20.6 27.392-.878 65.78.431 90.249-12.96 20.354-11.138 25.639-32.568 31.959-54.49.001.001 20.334-70.51-4.372-96.425z"
        fill="#98a4fa"
      />
      <path
        data-name="Path 1393"
        d="M2275.722 924.825c4.882 22.577 39.51-31.629 47.1-29.306 18.505 5.663 41.522 10.158 58.183.939 9.307-5.149 11.337-17.77 16.013-27.943 5.471-11.9 18.725-31.94 16.947-44.812-3.052-22.078-27.844-19.657-27.844-19.657-7.451-6.687-13.538 26.025-18.62 23.594-3.072-1.47 30.3-6.962 26.932-6.557-13.93 1.672-24.705 12.695-36.468 20.521-7.417 4.935-15.5 8.7-23.552 12.456a41.285 41.285 0 01-7.34 2.867c-4.235 1.058-8.664.74-13.013 1.035-4.461.3 14.469 16.548 10.1 17.5-4.251.924-13.854 2.4-15.539 6.5-1.043 2.546-24.823.69-23.906 3.286 2.893 8.179 15.428 4.243 23.558 6.754"
        transform="translate(-1977.87 -478.31)"
        fill="url(#prefix__d)"
      />
      <g data-name="Group 918">
        <path
          data-name="Path 1394"
          d="M2066.729 933.882a1.9 1.9 0 000-3.79 1.9 1.9 0 000 3.79z"
          transform="translate(-1926.829 -509.044)"
          fill="url(#prefix__e)"
        />
      </g>
      <g data-name="Group 919">
        <path
          data-name="Path 1395"
          d="M339.616 391.074q3.127-.558 6.233-1.233a23.919 23.919 0 005.772-1.858 23.42 23.42 0 004.652-3.339c1.349-1.176 3.093-2.486 2.97-4.478-.089-1.454-2.364-1.463-2.274 0 .051.829-.625 1.366-1.189 1.882q-.978.894-2 1.74a16.213 16.213 0 01-4.27 2.668c-3.3 1.307-7.023 1.805-10.5 2.425-1.438.256-.828 2.448.6 2.193z"
          fill="#98a4fa"
        />
      </g>
      <path
        data-name="Path 1396"
        d="M347.213 364.337s18.034 4.171 23.452-10.345l7.131 6.848-1.982 28.133-37.645-28.697"
        fill="#eaedfd"
        stroke="#eaedfd"
        strokeMiterlimit={10}
      />
      <g data-name="Group 920">
        <path
          data-name="Path 1397"
          d="M352.568 361.126a10.756 10.756 0 00.576 3.123l1.9-1.107-1.118-1.354a1.128 1.128 0 00-1.492-.089 1.156 1.156 0 00-.294 1.467 9.277 9.277 0 001.382 2.136 1.138 1.138 0 001.786-1.377 17.97 17.97 0 00-1.366-1.818 1.144 1.144 0 00-1.378-.177 1.2 1.2 0 00-.522 1.284 2.838 2.838 0 00.519 1.236l1.555-1.556a6.307 6.307 0 00-2.255-1.007l.794 1.4c-.132.345-.039.092.01.012.029-.049.068-.093.094-.143-.148.27-.1.13-.03.053a3.21 3.21 0 01.166-.164c.191-.177.4-.332.606-.493a3.463 3.463 0 001.214-1.6h-2.193a23.017 23.017 0 00.637 2.976 4.45 4.45 0 001.606 2.518 1.142 1.142 0 001.556-.408 1.17 1.17 0 00-.409-1.556c.269.195.012 0-.043-.053l-.1-.1c-.077-.093-.061-.073.046.061 0 0-.238-.4-.254-.437s-.042-.088-.061-.133c.067.158.077.181.031.067-.032-.093-.067-.185-.1-.279-.055-.169-.1-.34-.15-.512a23.941 23.941 0 01-.573-2.746 1.137 1.137 0 00-1.1-.834 1.187 1.187 0 00-1.1.834c-.064.185.144-.267 0-.009-.027.049-.07.094-.092.144.105-.246.119-.146.036-.052a2.832 2.832 0 01-.162.167c-.189.178-.4.334-.6.493a3.634 3.634 0 00-1.238 1.589 1.143 1.143 0 00.793 1.4c.164.038.327.08.488.133.08.026.159.057.239.083q.176.069-.037-.02l.114.052a5.428 5.428 0 01.908.532 1.138 1.138 0 001.556-1.556 2.3 2.3 0 01-.138-.2q-.031-.053-.059-.107c-.038-.076-.028-.047.031.086a1.212 1.212 0 01-.124-.471l-1.9 1.107c.1.114.194.23.289.346a7.717 7.717 0 01.18.233q.283.38.541.777l1.786-1.378c-.02-.023-.232-.276-.123-.145s-.069-.092-.088-.12q-.16-.221-.3-.452a8.216 8.216 0 01-.512-.961l-1.785 1.378 1.118 1.354a1.141 1.141 0 001.378.178 1.154 1.154 0 00.522-1.284 9.747 9.747 0 01-.367-1.345c-.02-.1-.039-.207-.055-.31l-.027-.178q.03.23.007.034c-.021-.24-.043-.478-.053-.719a1.137 1.137 0 10-2.273 0z"
          fill="#eaedfd"
        />
      </g>
      <g data-name="Group 921">
        <path
          data-name="Path 1398"
          d="M352.775 360.793l1.983 6.617a1.137 1.137 0 002.193-.6l-1.983-6.617a1.137 1.137 0 00-2.193.6z"
          fill="#eaedfd"
        />
      </g>
      <g data-name="Group 922">
        <path
          data-name="Path 1399"
          d="M351.848 357.476c.226 1.825.526 3.638.921 5.434l2.192-.6-1.291-3.988a1.145 1.145 0 00-1.248-.815 1.133 1.133 0 00-.987 1.117 30.325 30.325 0 00.32 3.418 1.122 1.122 0 00.522.68 1.178 1.178 0 00.725.135 1.133 1.133 0 00.985-1.117l-.017-1.238a1.139 1.139 0 00-2.234-.3l-.374 1.171a1.147 1.147 0 00.794 1.4 1.162 1.162 0 001.4-.794l.374-1.17-2.232-.3.018 1.238 2.233-.3c-.007-.047-.072-.47-.03-.2-.021-.133-.033-.267-.049-.4a28.139 28.139 0 01-.072-.7q-.065-.755-.089-1.512l-2.233.3 1.292 3.989a1.137 1.137 0 102.192-.6q-.274-1.247-.493-2.506-.107-.617-.2-1.236l-.085-.6a.749.749 0 01-.012-.1c-.017-.132-.035-.264-.05-.4a1.253 1.253 0 00-.333-.8 1.155 1.155 0 00-.8-.333c-.554.025-1.216.5-1.137 1.137z"
          fill="#eaedfd"
        />
      </g>
      <g data-name="Group 923">
        <path
          data-name="Path 1400"
          d="M352.519 360.724a21.221 21.221 0 011.394 2.44q.151.312.292.628c.021.046.181.414.068.151.042.1.082.2.122.3q.266.663.487 1.344a1.137 1.137 0 002.192-.6 22.435 22.435 0 00-2.591-5.4 1.137 1.137 0 10-1.964 1.148z"
          fill="#eaedfd"
        />
      </g>
      <g data-name="Group 924">
        <path
          data-name="Path 1401"
          d="M350.535 356.838v.214a1.167 1.167 0 001.137 1.137l.3-.041a1.135 1.135 0 00.5-.293l.178-.23a1.135 1.135 0 00.155-.574v-.214a1.256 1.256 0 00-.333-.8.847.847 0 00-.365-.235.867.867 0 00-.438-.1l-.3.041a1.137 1.137 0 00-.5.292l-.177.23a1.135 1.135 0 00-.155.574z"
          fill="#eaedfd"
        />
      </g>
      <g data-name="Group 925">
        <path
          data-name="Path 1402"
          d="M352.505 359.983a56.694 56.694 0 013.215 5.989 1.141 1.141 0 001.555.408 1.169 1.169 0 00.407-1.555 56.717 56.717 0 00-3.214-5.989 1.137 1.137 0 10-1.964 1.148z"
          fill="#eaedfd"
        />
      </g>
      <g data-name="Group 926" fill="#091572">
        <path
          data-name="Path 1403"
          d="M272.554 467.577a29.362 29.362 0 01-3.809-.23c-1-.564-1.534-1.191-1.582-1.869-.125-1.743 2.409-4.2 3.774-5.214l18.207-7.881a1.516 1.516 0 00.728-.665c14.924-27.317 27.867-49.721 29.619-52.745 16.241-9.359 44.916-10.014 45.2-10.019a1.527 1.527 0 00.738-.208l7.063-4.134 20.173 18.046c-4.192 10.634-20.3 12.9-33.263 12.9a159.341 159.341 0 01-28.078-2.78 1.548 1.548 0 00-.3-.031 1.517 1.517 0 00-1.5 1.753c1.04 6.558-4.795 16.248-16.873 28.023a194.737 194.737 0 01-19.244 16.282 1.574 1.574 0 00-.264.242c-6.353 7.421-15.627 8.529-20.589 8.53z"
        />
        <path
          data-name="Path 1404"
          d="M372.31 386.478l18.529 16.575c-4.481 9.03-19.358 10.992-31.431 10.992a157.829 157.829 0 01-27.773-2.749 3.032 3.032 0 00-3.6 3.445c.944 5.959-4.883 15.434-16.41 26.677a193.418 193.418 0 01-19.1 16.161 3 3 0 00-.527.485c-5.965 6.958-14.742 8-19.442 8a28.932 28.932 0 01-3.3-.179 1.655 1.655 0 01-.575-.508c-.1-.6 1.293-2.456 3.032-3.792l18.039-7.808a3.031 3.031 0 001.456-1.329c14.431-26.416 27.011-48.236 29.4-52.358 15.953-8.969 43.843-9.612 44.128-9.618a3.036 3.036 0 001.473-.414l6.111-3.577m.376-3.732l-8.018 4.693s-29.567.56-46.286 10.427c0 0-13.669 23.525-29.839 53.126l-18.364 7.948s-8.77 6.3-1.919 9.867a28.318 28.318 0 004.294.286c5.483 0 15.06-1.259 21.744-9.056 0 0 39.466-28.483 36.726-45.772a159.517 159.517 0 0028.383 2.811c15.072 0 31.256-2.947 35.031-14.87l-21.753-19.46z"
        />
      </g>
      <path
        data-name="Path 1405"
        d="M303.361 402.994s-10.859-40.951 1.221-62.477c0 0 7.784-13.166 59.469 33.835l4.546 20.143-23.845.28s-20.637-12.029-27.352-30.439c0 0 4.2 13.094-4.121 33.851l1.324 11.7-1.958 7.834-29.064 1.275s1.648-6.7 9.761-8.1z"
        fill="#091572"
      />
      <path
        data-name="Path 1406"
        d="M405.557 324.554s49.391 8.034 10.042 59.31c-4.518 5.887-8.176 18.486-15.3 25.459a47.371 47.371 0 01-31.7-14.828s-2.9-18.813-8.48-23.68c0 0 14.356 1.858 18.273-7.654 0 0-4.524-13.708 3.357-22.381"
        fill="#fccb88"
      />
      <path
        data-name="Path 1407"
        d="M395.467 326.932s-12.445-2.378-20.979 12.679c-1.836 3.238-3.593 8.773-7.444 11.506 0 0 2.651 6.38 14.2 6.52s22.671-12.24 22.671-12.24-5.034-15.736-5.034-16.366"
        fill="#fccb88"
      />
      <path
        data-name="Path 1408"
        d="M392.726 321.128a16.765 16.765 0 002.412 9.2 1.48 1.48 0 001.407.875c4.133.444 7.708-4.328 11.7-5.47-1.525-4.206-1.615-5.117-1.3-9.581.068-.96.079-2.13-.744-2.63a2.357 2.357 0 00-1.12-.258 15.547 15.547 0 00-8.328 1.966 7.024 7.024 0 00-1.922 1.474 9.112 9.112 0 00-1.206 2.024l-1.279 2.662"
        fill="#eaedfd"
      />
      <path
        data-name="Path 1409"
        d="M393.184 325.572a7.146 7.146 0 006.175-1.63 8.284 8.284 0 003.073-5.937 12.933 12.933 0 01-9.837 4.106 16.861 16.861 0 00.589 3.461"
        fill="#98a4fa"
      />
      <rect
        data-name="Rectangle 627"
        width={3.217}
        height={28.082}
        rx={1.609}
        transform="rotate(-50.2 532.295 -177.112)"
        fill="#374adb"
      />
      <path
        data-name="Path 1410"
        d="M383.961 301.365l-.036 5.176a34.651 34.651 0 00.6 8.256 11.655 11.655 0 004.261 6.913c3.315 2.358 8.06 2.039 11.514-.111s5.73-5.833 6.983-9.7c1.534-4.741 1.478-10.482-1.948-14.1a11.219 11.219 0 00-3.377-2.387 14.107 14.107 0 00-17.893 6.093"
        fill="#eaedfd"
      />
      <g data-name="Group 927">
        <path
          data-name="Path 1411"
          d="M385.817 307.862c2.9.674 3.323 4.139 3.431 6.594.021.486.779.489.758 0a11.427 11.427 0 00-.95-4.784 4.753 4.753 0 00-3.038-2.541c-.474-.11-.677.621-.2.731z"
          fill="#98a4fa"
        />
      </g>
      <g data-name="Group 929">
        <path
          data-name="Path 1412"
          d="M374.607 296.557a8.836 8.836 0 003.341 8.358 9.646 9.646 0 009.3 1.589 16.378 16.378 0 003.13-1.664q2.046-1.315 3.98-2.795c1.193-.913 2.584-1.931 4.049-1.6a3.526 3.526 0 012.369 3.4c.058 1.267-.631 3.4.345 4.2.771-.088 1.253-1.764 1.516-2.494a2.691 2.691 0 013.318-1.315c1.879.522 2.383 3.226 2.293 4.555s-1.451 2.556-2.5 3.37c-.4 2.794.093 4.381 1.169 6.992a10.093 10.093 0 011.027-4.433 35.827 35.827 0 013.34-4.468c2.291-3.045 1.5-6.439-.378-9.015a9.565 9.565 0 003.092-3.822 4.966 4.966 0 00-.436-4.74 4.031 4.031 0 00-4.585-1.279 5.831 5.831 0 00-2.268-6.3 7.425 7.425 0 00-6.842-.706 10.312 10.312 0 00-5.188 4.725 5.428 5.428 0 00-3.25-2.4 8.462 8.462 0 00-5.143-.384 6.405 6.405 0 00-3.965 3.3c-.989 2.124.047 3.182-.22 4.922-2.04-1.344-6.6-.267-7.489 2.007"
          fill="#091572"
        />
        <g data-name="Group 928">
          <path
            data-name="Path 1413"
            d="M374.242 296.455a9.634 9.634 0 006.366 10.391 9.993 9.993 0 006.535.095 15.974 15.974 0 003.426-1.774q1.743-1.12 3.406-2.361a9.507 9.507 0 013.267-1.974 2.41 2.41 0 012.736 1.414 4.889 4.889 0 01.34 2.86 4.836 4.836 0 00.172 2.75c.167.316.419.632.809.543a1.518 1.518 0 00.828-.684c.479-.7.566-1.585.995-2.3a2.447 2.447 0 012.734-.81 2.689 2.689 0 011.64 1.762 5.23 5.23 0 01.356 2.583c-.212 1.259-1.386 2.08-2.272 2.866-.41.364-.329 1.279-.346 1.807a9.989 9.989 0 00.109 1.8 16.714 16.714 0 001.207 3.83.381.381 0 00.744-.1 9.912 9.912 0 01.9-4.1 18.575 18.575 0 012.433-3.378 10.553 10.553 0 002.117-3.4 7.056 7.056 0 00.175-3.519 9.591 9.591 0 00-1.688-3.711l-.059.459c2.19-1.755 4.108-4.325 3.482-7.291a4.381 4.381 0 00-5.781-3.183l.467.466a6.267 6.267 0 00-3.138-7.156 8.241 8.241 0 00-8.51.789 11.541 11.541 0 00-3.341 3.793h.654a5.455 5.455 0 00-2.938-2.373 10.2 10.2 0 00-4.462-.835 6.648 6.648 0 00-5.981 4.743c-.321 1.355.293 2.641.111 3.989l.556-.227a5.852 5.852 0 00-4.522-.377 5.013 5.013 0 00-3.523 2.61c-.187.449.546.646.731.2.495-1.194 1.938-1.82 3.105-2.11a5.043 5.043 0 013.828.329.38.38 0 00.556-.226c.182-1.341-.422-2.665-.109-3.989a5.576 5.576 0 012.926-3.52 6.943 6.943 0 015.071-.363c1.52.4 3.23 1.056 4 2.528a.381.381 0 00.654 0 9.576 9.576 0 016.108-4.89 6.4 6.4 0 016.964 2.753 5.219 5.219 0 01.533 4.127.381.381 0 00.466.466 3.635 3.635 0 014.9 2.962c.344 2.593-1.448 4.731-3.34 6.246a.378.378 0 00-.059.459 8.555 8.555 0 011.707 4.212 6.566 6.566 0 01-1.5 4.643 34.657 34.657 0 00-3.051 4.03 10.517 10.517 0 00-1.2 4.84l.745-.1a13.041 13.041 0 01-1.283-5.584 9.43 9.43 0 01.063-.8c.043-.334.125-.371.374-.577a9.643 9.643 0 001.052-.991 4.024 4.024 0 001.138-2.246 5.934 5.934 0 00-.96-3.8 3.284 3.284 0 00-3.982-1.054 2.677 2.677 0 00-1.51 1.736c-.186.538-.478 1.815-1.15 1.939l.369.1c-.756-.684-.359-2.165-.274-3.043a4.929 4.929 0 00-.716-3.27 3.089 3.089 0 00-2.941-1.439 8.193 8.193 0 00-3.722 2.015 56.448 56.448 0 01-3.978 2.741 11.9 11.9 0 01-4.006 1.742 9.277 9.277 0 01-7.593-1.928 8.626 8.626 0 01-3.187-7.942c.075-.477-.655-.683-.731-.2z"
            fill="#091572"
          />
        </g>
      </g>
      <g data-name="Group 930">
        <path
          data-name="Path 1414"
          d="M404.937 308.519a2.09 2.09 0 01-.023-.138l.014.1a1.416 1.416 0 010-.371l-.014.1a.952.952 0 01.055-.211l-.038.09a.824.824 0 01.056-.109.25.25 0 01.036-.055l-.036.047.025-.028.039-.039.029-.024-.048.036c.014-.026.088-.051.113-.062l-.09.039a.552.552 0 01.122-.032l-.1.014a.509.509 0 01.117 0l-.1-.013a.54.54 0 01.114.032l-.091-.038a.522.522 0 01.06.03l.028.018s-.08-.074-.032-.023c.013.014.064.073.02.017s0 .014.011.032l-.038-.09a.4.4 0 01.026.1l-.013-.1a.472.472 0 010 .1l.014-.1a.526.526 0 01-.034.114l.039-.09a.92.92 0 01-.06.108c-.018.026-.062.064.009-.009-.014.015-.028.033-.041.049a2.09 2.09 0 01-.193.184.834.834 0 00-.107.088l.04-.031-.036.028-.056.04a1.439 1.439 0 01-.224.139l.091-.039a.324.324 0 01-.052.016l.1-.014a.133.133 0 01-.034 0l.1.014h-.016l.091.039c-.057-.027-.028 0 .087.093l.038.09a.111.111 0 01-.009-.032l.013.1a.264.264 0 010-.054l-.013.1a1.025 1.025 0 01.058-.174l-.037.091a1.787 1.787 0 01.167-.312l.049-.07c.027-.039-.05.062-.02.026l.027-.033a1.82 1.82 0 01.125-.133.38.38 0 00-.537-.536 2.182 2.182 0 00-.372.483 2.5 2.5 0 00-.141.3.664.664 0 00-.052.409.465.465 0 00.439.358.666.666 0 00.366-.117 3.467 3.467 0 00.516-.393 1.357 1.357 0 00.387-.551.75.75 0 00-.143-.716.837.837 0 00-.583-.285.869.869 0 00-.618.215 1.087 1.087 0 00-.359.584 1.867 1.867 0 00.011.8.38.38 0 00.466.264.388.388 0 00.264-.466z"
          fill="#98a4fa"
        />
      </g>
      <g data-name="Group 932">
        <path
          data-name="Path 1415"
          d="M340.883 354.048c4.134-1.227 7.7-3.887 11.758-5.351a21.755 21.755 0 0114.057-.2c5.468 1.8 9.955 5.67 14.545 9.142s9.757 6.732 15.509 6.939h9.332l6.994 6-8.533 8.953c-12.865 6.724-23.08-7.923-30.686-15.87-2.849-2.976-5.635-6.617-9.439-8.307"
          fill="#eaedfd"
        />
        <g data-name="Group 931">
          <path
            data-name="Path 1416"
            d="M340.987 354.413a45.69 45.69 0 007.621-3.472 26.554 26.554 0 018.094-2.888 21.369 21.369 0 018.755.468 26.816 26.816 0 017.511 3.486c4.648 2.985 8.688 6.833 13.476 9.613a24.706 24.706 0 007.511 3 20.2 20.2 0 003.983.332h8.147l-.268-.111 6.109 5.24.885.76v-.536l-5.3 5.562-2.85 2.99a2.315 2.315 0 01-.864.621 14.465 14.465 0 01-3.5 1.162c-4.543.874-8.9-.994-12.524-3.619-3.886-2.819-7.12-6.45-10.316-10-1.564-1.74-3.172-3.436-4.751-5.163a33.8 33.8 0 00-6.269-5.84 13.651 13.651 0 00-1.823-1c-.44-.2-.826.453-.382.654a22.012 22.012 0 016.806 5.484c1.7 1.832 3.41 3.651 5.082 5.506a82.972 82.972 0 0010.3 10.281c3.548 2.763 7.817 4.977 12.44 4.642a14.01 14.01 0 003.444-.693 16.678 16.678 0 001.688-.674 3.411 3.411 0 00.864-.471c.776-.7 1.462-1.533 2.18-2.288l6.177-6.481.134-.14a.383.383 0 000-.536l-6.8-5.834a.987.987 0 00-.747-.277h-7.794a19.448 19.448 0 01-6.306-.966 34.981 34.981 0 01-9.354-5.243c-5.648-4.154-11.062-9.181-18.181-10.54a22.251 22.251 0 00-10.976.663c-3.473 1.126-6.533 3.172-9.861 4.631a22.627 22.627 0 01-2.542.94.38.38 0 00.2.731z"
            fill="#eaedfd"
          />
        </g>
      </g>
      <g data-name="Group 934">
        <path
          data-name="Path 1417"
          d="M344.911 354.664a3.154 3.154 0 002.562.638 15.492 15.492 0 004.684-1.114 1.282 1.282 0 01.7-.147 1.313 1.313 0 01.562.331c2.917 2.4 6.789.979 10.635 1.1l-2.167-3.5h-14l-6.945 2.445a.841.841 0 00.694.758 2.367 2.367 0 001.1-.1 40.939 40.939 0 007.071-2.509"
          fill="#eaedfd"
        />
        <g data-name="Group 933">
          <path
            data-name="Path 1418"
            d="M344.642 354.931a4 4 0 003.346.7 16.712 16.712 0 004.269-1.079.928.928 0 01.552-.118 1.068 1.068 0 01.4.252 6.84 6.84 0 00.755.528 6.368 6.368 0 001.668.679 12.184 12.184 0 003.808.208c1.537-.1 3.068-.3 4.611-.257a.382.382 0 00.327-.571l-1.423-2.3c-.231-.372-.452-.753-.694-1.119a.535.535 0 00-.46-.269c-.569-.042-1.157 0-1.727 0h-10.243c-.608 0-1.219-.017-1.825 0a3.993 3.993 0 00-1.158.344l-6.006 2.115a.385.385 0 00-.278.365c.167 1.969 2.923.872 3.994.549a42.177 42.177 0 005.437-2.069c.443-.2.058-.856-.382-.654a40.713 40.713 0 01-4.234 1.669c-.55.182-3.973 1.52-4.059.506l-.278.366 4.137-1.457 2.366-.833c.145-.052.29-.111.439-.155-.192.056.024.012.111.012h13.792l-.326-.188 2.167 3.5.327-.57c-1.671-.042-3.325.19-4.99.28a8.4 8.4 0 01-4.589-.735c-.606-.336-1.149-1.057-1.9-.965a5.709 5.709 0 00-1.159.4q-.649.234-1.319.409a14.275 14.275 0 01-2.756.454 2.762 2.762 0 01-2.157-.537c-.352-.338-.888.2-.536.536z"
            fill="#eaedfd"
          />
        </g>
      </g>
      <g data-name="Group 936">
        <path
          data-name="Path 1419"
          d="M341.333 350.816c1.73-1.06 3.236-2.88 5.744-1.836.88.366 1.906-.024 2.858-.068a16.039 16.039 0 003.416-.528l1.4 2.356"
          fill="#eaedfd"
        />
        <g data-name="Group 935">
          <path
            data-name="Path 1420"
            d="M341.524 351.144c1.494-.931 2.94-2.489 4.869-2a6.273 6.273 0 001.526.365 14.39 14.39 0 001.7-.2 25.826 25.826 0 003.836-.568l-.428-.174 1.4 2.356a.379.379 0 00.654-.382l-1.4-2.357a.39.39 0 00-.428-.174 16.019 16.019 0 01-2.045.407c-.615.079-1.237.084-1.852.168a5.318 5.318 0 01-1.876.117 11.761 11.761 0 00-1.532-.4c-1.915-.18-3.3 1.25-4.8 2.183-.413.258-.034.914.382.655z"
            fill="#eaedfd"
          />
        </g>
      </g>
      <g data-name="Group 938">
        <path
          data-name="Path 1421"
          d="M341.813 351.06c.663.1-.668.049 0 0 2.039-.151 4.07-.991 6.074-.584"
          fill="#98a4fa"
        />
        <g data-name="Group 937">
          <path
            data-name="Path 1422"
            d="M341.711 351.425a.774.774 0 00.116.021c.114 0 .1.207-.152-.15l.06-.459a.32.32 0 01.223-.1h-.047a.578.578 0 00-.1 0 .511.511 0 00-.1-.007c-.045 0-.033 0 .035.005-.071-.019-.024.01.142.086v.536q-.249.115-.135.086-.082.009.006 0a2.033 2.033 0 00.389-.035c.257-.028.512-.064.768-.1.539-.086 1.072-.2 1.608-.3a8.71 8.71 0 013.264-.164c.476.092.68-.639.2-.731a9.6 9.6 0 00-3.612.153c-.591.111-1.179.236-1.774.327-.288.044-.576.067-.866.1a.546.546 0 00-.384.134.393.393 0 000 .536.805.805 0 00.919.014.383.383 0 00.059-.459.548.548 0 00-.417-.218c-.477-.075-.683.656-.2.731z"
            fill="#98a4fa"
          />
        </g>
      </g>
      <g data-name="Group 939">
        <path
          data-name="Path 1423"
          d="M346.284 397.529a.379.379 0 000-.758.379.379 0 000 .758z"
          fill="#091572"
        />
      </g>
      <path
        data-name="Path 1424"
        d="M392.595 360.508s9.85 6.331 12.962 21.262c0 0 5.425-.42 5.565-1.12s4.615-8.253 4.336-9.511-1.679-12.45-2.377-13.989-15.567-4.2-15.567-4.2"
        fill="#fccb88"
      />
      <g data-name="Group 940">
        <path
          data-name="Path 1425"
          d="M404.477 345.393c-.917 6.877-6.872 11.4-12.064 15.231-.388.286-.01.944.383.654 4.363-3.218 8.956-6.646 11.245-11.732a14.856 14.856 0 001.193-4.153c.064-.481-.7-.477-.757 0z"
          fill="#fff"
        />
      </g>
      <g data-name="Group 941">
        <path
          data-name="Path 1426"
          d="M392.514 361.167a18.073 18.073 0 014.9 4.716 39.07 39.07 0 014.586 7.211 18.8 18.8 0 011.451 3.9c.111.475.842.274.73-.2a25.109 25.109 0 00-3.34-7.35 37.667 37.667 0 00-5.2-6.722 12.807 12.807 0 00-2.744-2.212.379.379 0 00-.382.654z"
          fill="#fff"
        />
      </g>
      <g data-name="Group 942">
        <path
          data-name="Path 1427"
          d="M403.453 376.999a15.908 15.908 0 004.522 6.986.385.385 0 00.6-.077 124.443 124.443 0 018.065-12.5c.289-.394-.369-.772-.654-.383a124.368 124.368 0 00-8.065 12.5l.595-.076a15.15 15.15 0 01-4.328-6.651c-.149-.463-.88-.265-.731.2z"
          fill="#fff"
        />
      </g>
      <g data-name="Group 943">
        <path
          data-name="Path 1428"
          d="M393.364 331.611a7.153 7.153 0 002.255 1.782 6.961 6.961 0 004.779-.027c.465-.141.267-.873-.2-.731a6.181 6.181 0 01-4.31.052 6.632 6.632 0 01-1.986-1.611c-.338-.353-.874.183-.536.536z"
          fill="#fff"
        />
      </g>
      <g data-name="Group 944">
        <path
          data-name="Path 1429"
          d="M381.055 341.809a18.23 18.23 0 00-1.764 8.341 25.564 25.564 0 001.59 7.588c.161.457.894.261.731-.2a25.125 25.125 0 01-1.559-7.234 17.407 17.407 0 011.657-8.111c.2-.44-.449-.825-.655-.383z"
          fill="#fff"
        />
      </g>
      <g data-name="Group 945">
        <path
          data-name="Path 1430"
          d="M344.527 355.234c2.865-1.038 5.438-2.747 8.159-4.091.438-.216.054-.87-.382-.655-2.661 1.313-5.178 3-7.979 4.015-.455.164-.258.9.2.731z"
          fill="#98a4fa"
        />
      </g>
      <g data-name="Group 946">
        <path
          data-name="Path 1431"
          d="M376.141 366.186a63.041 63.041 0 00-5.308-6.183q-1.38-1.408-2.849-2.725a6.625 6.625 0 00-3.115-2.008 4.431 4.431 0 00-1.8.19 13.951 13.951 0 01-2.3.449 11.521 11.521 0 01-4.01-.34 6.444 6.444 0 01-1.711-.7 13.728 13.728 0 00-1.2-.728 3.46 3.46 0 00-2.646-.123c-1.015.344-1.954.872-2.94 1.282a2.511 2.511 0 01-1.568.219 5.434 5.434 0 01-1.945-.977c-.4-.284-.776.373-.382.654a4.631 4.631 0 003.2 1.11 9.386 9.386 0 002.441-.972 5.444 5.444 0 012.59-.766 7.079 7.079 0 012.526 1.21 11.375 11.375 0 007.618.553 4.882 4.882 0 012.074-.3 3.952 3.952 0 011.734 1c1 .849 1.957 1.745 2.892 2.661a61.347 61.347 0 016.038 6.879c.291.385.949.008.655-.383z"
          fill="#98a4fa"
        />
      </g>
      <g data-name="Group 947">
        <path
          data-name="Path 1434"
          d="M340.092 353.993a1.845 1.845 0 001.542 1.673 11.1 11.1 0 002.727-.151c.487-.017.489-.775 0-.758a20.325 20.325 0 01-2.3.211c-.537-.041-1.2-.358-1.214-.975a.379.379 0 00-.758 0z"
          fill="#98a4fa"
        />
      </g>
      <path
        data-name="Path 1435"
        d="M289.614 449.032s-1.041 5.922 9.959 6.963l-5.274 4.042s-14.489.568-7.372-8.345l1.744-1.285z"
        fill="#374adb"
      />
      <g data-name="Group 948">
        <path
          data-name="Path 1436"
          d="M336.08 390.817c5.281-.743 10.448-2.041 15.771-2.566a62.583 62.583 0 015.084-.308c1.417-.026 2.833.1 4.249.075.872-.016 2.428-.109 2.44-1.3a3.119 3.119 0 00-.908-1.8 25.847 25.847 0 00-3.6-3.392c-.334-.278-.82.2-.481.483a33.385 33.385 0 013.063 2.782c.414.44 1.168 1.141 1.23 1.8.11 1.161-2.952.71-3.541.69a78.906 78.906 0 00-16.957 1.684c-2.173.4-4.339.889-6.529 1.2-.433.061-.249.718.182.658z"
          fill="#98a4fa"
        />
      </g>
      <path
        data-name="Path 1437"
        d="M302.734 400.4s7.128 1.285 10.415-1.855l.578 5.1-10.5-.3"
        fill="#374adb"
      />
      <g data-name="Group 950" fill="#fccb88">
        <g data-name="Group 949">
          <path
            data-name="Path 1438"
            d="M186.702 479.186c.007.15.012.3.012.453 0-.152 0-.3.011-.453z"
          />
          <path
            data-name="Path 1439"
            d="M176.595 489.311c.15-.007.3-.011.452-.011-.152 0-.3 0-.452-.012z"
          />
          <path
            data-name="Path 1440"
            d="M186.725 499.416c-.007-.15-.011-.3-.011-.452 0 .152 0 .3-.012.452z"
          />
          <path
            data-name="Path 1441"
            d="M186.713 479.633q0 .5-.05.988a9.828 9.828 0 01-.146.96 9.6 9.6 0 01-.563 1.814q-.184.433-.407.845a10.541 10.541 0 01-.754 1.176 9.751 9.751 0 01-1.962 1.962 8.898 8.898 0 01-.52.36 9.41 9.41 0 01-1.5.801 9.619 9.619 0 01-1.814.563q-.472.1-.959.146a9.668 9.668 0 01-.989.05 9.7 9.7 0 01.989.05 9.446 9.446 0 01.959.146 9.575 9.575 0 011.814.563 9.41 9.41 0 011.5.801c.177.115.352.233.52.359a9.792 9.792 0 011.962 1.963 10.411 10.411 0 01.754 1.175q.223.411.407.845a9.607 9.607 0 01.563 1.814q.1.472.146.959t.05.988a9.666 9.666 0 019.666-9.666 9.666 9.666 0 01-9.666-9.662z"
          />
        </g>
        <path
          data-name="Path 1443"
          d="M176.595 489.311c.15-.007.3-.011.452-.011-.152 0-.3 0-.452-.012z"
        />
        <path
          data-name="Path 1444"
          d="M186.725 499.416c-.007-.15-.011-.3-.011-.452 0 .152 0 .3-.012.452z"
        />
        <path
          data-name="Path 1445"
          d="M186.713 479.633q0 .5-.05.988a9.828 9.828 0 01-.146.96 9.6 9.6 0 01-.563 1.814q-.184.433-.407.845a10.541 10.541 0 01-.754 1.176 9.751 9.751 0 01-1.962 1.962 8.898 8.898 0 01-.52.36 9.41 9.41 0 01-1.5.801 9.619 9.619 0 01-1.814.563q-.472.1-.959.146a9.668 9.668 0 01-.989.05 9.7 9.7 0 01.989.05 9.446 9.446 0 01.959.146 9.575 9.575 0 011.814.563 9.41 9.41 0 011.5.801c.177.115.352.233.52.359a9.792 9.792 0 011.962 1.963 10.411 10.411 0 01.754 1.175q.223.411.407.845a9.607 9.607 0 01.563 1.814q.1.472.146.959t.05.988a9.666 9.666 0 019.666-9.666 9.666 9.666 0 01-9.666-9.662z"
        />
        <path
          data-name="Path 1446"
          d="M186.702 479.186c.007.15.012.3.012.453 0-.152 0-.3.011-.453z"
        />
      </g>
      <g data-name="Group 952" fill="#fccb88">
        <g data-name="Group 951">
          <path
            data-name="Path 1447"
            d="M101.255 495.881c.011.245.018.49.018.737 0-.247.008-.493.019-.737z"
          />
          <path
            data-name="Path 1448"
            d="M84.774 512.399c.245-.012.49-.019.737-.019-.247 0-.492-.007-.737-.018z"
          />
          <path
            data-name="Path 1449"
            d="M101.292 528.88c-.011-.245-.019-.49-.019-.737 0 .247-.007.493-.018.737z"
          />
          <path
            data-name="Path 1450"
            d="M101.273 496.615a15.925 15.925 0 01-.081 1.612 15.653 15.653 0 01-1.157 4.523q-.3.707-.664 1.378c-.2.367-.415.722-.642 1.07-.187.288-.381.573-.586.847a15.892 15.892 0 01-3.2 3.2c-.275.205-.56.4-.848.587a15.466 15.466 0 01-2.448 1.306 15.638 15.638 0 01-2.958.918q-.77.157-1.565.239a15.962 15.962 0 01-1.612.081 15.961 15.961 0 011.612.082 15.641 15.641 0 014.523 1.157q.709.3 1.378.663c.367.2.722.416 1.07.643.289.188.573.381.848.587a15.9 15.9 0 013.2 3.2c.205.275.4.559.586.848.227.348.444.7.642 1.069q.365.671.664 1.378a15.661 15.661 0 011.157 4.524 15.917 15.917 0 01.081 1.612 15.763 15.763 0 0115.763-15.763 15.763 15.763 0 01-15.763-15.761z"
          />
        </g>
        <path
          data-name="Path 1452"
          d="M84.774 512.399c.245-.012.49-.019.737-.019-.247 0-.492-.007-.737-.018z"
        />
        <path
          data-name="Path 1453"
          d="M101.292 528.88c-.011-.245-.019-.49-.019-.737 0 .247-.007.493-.018.737z"
        />
        <path
          data-name="Path 1454"
          d="M101.273 496.615a15.925 15.925 0 01-.081 1.612 15.653 15.653 0 01-1.157 4.523q-.3.707-.664 1.378c-.2.367-.415.722-.642 1.07-.187.288-.381.573-.586.847a15.892 15.892 0 01-3.2 3.2c-.275.205-.56.4-.848.587a15.466 15.466 0 01-2.448 1.306 15.638 15.638 0 01-2.958.918q-.77.157-1.565.239a15.962 15.962 0 01-1.612.081 15.961 15.961 0 011.612.082 15.641 15.641 0 014.523 1.157q.709.3 1.378.663c.367.2.722.416 1.07.643.289.188.573.381.848.587a15.9 15.9 0 013.2 3.2c.205.275.4.559.586.848.227.348.444.7.642 1.069q.365.671.664 1.378a15.661 15.661 0 011.157 4.524 15.917 15.917 0 01.081 1.612 15.763 15.763 0 0115.763-15.763 15.763 15.763 0 01-15.763-15.761z"
        />
        <path
          data-name="Path 1455"
          d="M101.255 495.881c.011.245.018.49.018.737 0-.247.008-.493.019-.737z"
        />
      </g>
      <path
        data-name="Path 1456"
        d="M480.17 397.833a25.818 25.818 0 0010.446-1.82 60.12 60.12 0 009.514-4.759c1.529-.922 3.046-1.875 4.569-2.81 1.5-.966 3.02-1.912 4.495-2.922a192.806 192.806 0 008.785-6.141q8.643-6.339 16.647-13.509c5.356-4.75 10.443-9.8 15.46-14.974a135.125 135.125 0 01-14.249 16.269c-2.553 2.56-5.275 4.941-8 7.315q-4.15 3.493-8.51 6.729a156.036 156.036 0 01-18.325 11.583 52.746 52.746 0 01-10.035 4.274 23.484 23.484 0 01-10.797.765z"
        fill="#98a4fa"
      />
      <path
        data-name="Path 1457"
        d="M484.087 383.645a48.652 48.652 0 013.392-7.661 67.809 67.809 0 019.677-13.622 48.3 48.3 0 016.122-5.72c-1.529 2.355-3.141 4.6-4.743 6.838l-4.786 6.711-4.767 6.724c-1.59 2.25-3.176 4.515-4.895 6.73z"
        fill="#98a4fa"
      />
      <g data-name="Group 953">
        <path
          data-name="Path 1458"
          d="M349.98 357.195l-.8 2.349a1.982 1.982 0 00-.14.758 1.42 1.42 0 00.679 1.16 1.622 1.622 0 001.911-.24 6.353 6.353 0 00.732-.89c.292-.372.588-.741.872-1.12a2.641 2.641 0 00.4-2.773 1.468 1.468 0 00-2.037-.734 2.787 2.787 0 00-.6.59l-.489.555a1.137 1.137 0 001.608 1.608l.439-.5.194-.222c.042-.046.082-.093.122-.139.164-.184.033.067-.3.145h-.6a.765.765 0 01-.232-.135c-.082-.067-.092-.072-.032-.014-.113-.156-.145-.2-.1-.124a.549.549 0 01.041.069c-.047-.012-.1-.3-.038-.07a1.333 1.333 0 01.03.161l-.041-.3a1.563 1.563 0 01-.008.333l.041-.3a1.802 1.802 0 01-.078.289c.07-.158.087-.2.049-.119a3.883 3.883 0 01-.2.346c-.044.065-.091.128-.137.192-.125.174.156-.2.013-.017l-.276.353-.552.706c-.086.111-.17.224-.262.332-.03.036-.222.209-.058.085.085-.061.09-.067.016-.02.19-.068.233-.089.127-.064l.3-.04a.621.621 0 01-.14 0l.3.04c-.112-.026-.064 0 .142.071a.9.9 0 01.389.49l.04.3a.448.448 0 010-.125l-.04.3a10.749 10.749 0 01.439-1.327l.463-1.353a1.146 1.146 0 00-.794-1.4 1.165 1.165 0 00-1.4.794z"
          fill="#eaedfd"
        />
      </g>
      <g data-name="Group 954">
        <path
          data-name="Path 1459"
          d="M349.839 362.253a3.869 3.869 0 002.384-2.438.381.381 0 00-.264-.466.387.387 0 00-.466.264c-.02.061-.041.121-.064.181 0 .01-.045.108-.011.029l-.039.087a3.554 3.554 0 01-.175.325l-.1.161-.046.065c-.015.021-.058.078-.018.026a3.39 3.39 0 01-.253.29 3.532 3.532 0 01-.271.25l-.05.041c.035-.028-.031.023-.038.028-.052.038-.1.075-.158.11a3.462 3.462 0 01-.334.191 2.748 2.748 0 01-.174.081c.049-.021.018-.008-.014 0s-.069.027-.1.039a.379.379 0 10.2.731z"
          fill="#98a4fa"
        />
      </g>
      <g data-name="Group 955">
        <path
          data-name="Path 1460"
          d="M352.429 356.199c.718.2.93 1.139 1.128 1.755a11.8 11.8 0 00.917 2.347c.687 1.188 2.22 2.132 2.33 3.589.037.483.795.487.758 0-.132-1.739-1.726-2.669-2.5-4.093a19.325 19.325 0 01-.99-2.691 2.337 2.337 0 00-1.441-1.639.379.379 0 00-.2.731z"
          fill="#98a4fa"
        />
      </g>
      <path
        data-name="Path 1461"
        d="M427.407 407.88c-4.427-5.523-12.168-8.07-18.94-9.008a45.845 45.845 0 00-22.979 2.786 56.371 56.371 0 00-19.029 12.7 21.467 21.467 0 00-21.506 2.852c-1.187.332-2.354.666-3.486.988-5.149 1.466-4.091 8.492.058 9.572a5.341 5.341 0 007.5-1.039c.108-.147.229-.283.345-.423 2.021-.488 4.05-.929 6.1-1.307.8-.146 1.636-.317 2.5-.471a85.039 85.039 0 00-4.381 7.042c-2.547 4.571 2.416 8.728 6.741 6.74 3.783-1.739 6.822-4.51 9.953-7.2q1.171-1 2.387-1.946a38.643 38.643 0 00-.95 2.226c-2.3 5.911 7.22 8.472 9.5 2.619a25.039 25.039 0 011.792-3.657c.359-.073.72-.151 1.078-.248 6.795-1.834 11.847-7.158 17.991-10.3a37.87 37.87 0 0121.846-3.524c4.744.57 5.792-5.514 3.48-8.402z"
        fill="#98a4fa"
      />
    </svg>
  );
}
